import React from 'react';
import PropTypes from 'prop-types';
import styles from './Drawer.module.css';
import Stepper from '../../../Stepper/Stepper';

function ModalDrawer({ stepper }) {
  return (
    <div className={styles.drawer}>
      <div className={styles.drawerBody}>
        <Stepper
          steps={stepper.steps}
          activeStep={stepper.activeStep}
          displayedStep={stepper.displayedStep}
          editMode={stepper.editMode}
          approvalMode={stepper.approvalMode}
          clickable={false}
        />
      </div>
    </div>
  );
}

ModalDrawer.propTypes = {
  stepper: PropTypes.shape({
    steps: PropTypes.arrayOf(PropTypes.string),
    currentStep: PropTypes.number,
    displayedStep: PropTypes.number,
    editMode: PropTypes.bool,
    approvalMode: PropTypes.bool,
  }).isRequired,
};
export default ModalDrawer;
